import React from "react"

const SectionHowItWorks = () => (
  <section className="how-sec alt">
    <div className="wrap">
      <h2>How TEAM works</h2>
      <ol className="flow">
        <li>
          <span className="fn">1</span>
          <b>Care is billed as usual</b>
          <span>Providers bill Medicare fee-for-service.</span>
        </li>
        <li>
          <span className="fn">2</span>
          <b>CMS sets a target</b>
          <span>
            Regional baseline, risk adjusted, less a 1.5% or 2% discount.
          </span>
        </li>
        <li>
          <span className="fn">3</span>
          <b>CMS reconciles yearly</b>
          <span>Spending is compared to target across all episodes.</span>
        </li>
        <li>
          <span className="fn">4</span>
          <b>Quality adjusts the result</b>
          <span>Your quality score moves what you earn or owe.</span>
        </li>
      </ol>
      <h3 className="sub-h">Choose your level of risk</h3>
      <p className="sub-p">
        Each track caps gains and losses as a share of target spending.
        Hospitals pick a track each year.
      </p>
      <div className="trk" role="table" aria-label="TEAM risk tracks">
        <div className="trk-h" role="row">
          <span role="columnheader">Track</span>
          <span role="columnheader" className="c">
            Max loss
          </span>
          <span aria-hidden="true" />
          <span role="columnheader" className="c">
            Max gain
          </span>
          <span role="columnheader">Who</span>
        </div>
        <div className="trk-r t1" role="row">
          <span className="trk-n" role="cell">
            <b>Track 1</b>
            <em>Upside only</em>
          </span>
          <span className="lv l zero" role="cell">
            None
          </span>
          <span className="bars" aria-hidden="true">
            <i className="bl" style={{ "--w": "0%" }} />
            <i className="bg" style={{ "--w": "50%" }} />
          </span>
          <span className="lv g" role="cell">
            10%
          </span>
          <span className="who" role="cell">
            All hospitals in 2026. Safety net hospitals through 2028.
          </span>
        </div>
        <div className="trk-r t2" role="row">
          <span className="trk-n" role="cell">
            <b>Track 2</b>
            <em>Lower risk</em>
          </span>
          <span className="lv l" role="cell">
            5%
          </span>
          <span className="bars" aria-hidden="true">
            <i className="bl" style={{ "--w": "25%" }} />
            <i className="bg" style={{ "--w": "25%" }} />
          </span>
          <span className="lv g" role="cell">
            5%
          </span>
          <span className="who" role="cell">
            Safety net, rural, and other qualifying hospitals
          </span>
        </div>
        <div className="trk-r t3" role="row">
          <span className="trk-n" role="cell">
            <b>Track 3</b>
            <em>Full risk</em>
          </span>
          <span className="lv l" role="cell">
            20%
          </span>
          <span className="bars" aria-hidden="true">
            <i className="bl" style={{ "--w": "100%" }} />
            <i className="bg" style={{ "--w": "100%" }} />
          </span>
          <span className="lv g" role="cell">
            20%
          </span>
          <span className="who" role="cell">
            Any hospital
          </span>
        </div>
      </div>
      <h3 className="tl-h">What’s ahead</h3>
      <ol className="htl" style={{ gridTemplateColumns: "repeat(3,1fr)" }}>
        <li className="next">
          <span className="hd">Jan 2027</span>
          <span className="ht">Two-sided risk for most</span>
        </li>
        <li>
          <span className="hd">Apr 2027</span>
          <span className="ht">Next rule proposed</span>
        </li>
        <li>
          <span className="hd">Dec 2030</span>
          <span className="ht">TEAM ends</span>
        </li>
      </ol>
    </div>
  </section>
)

export default SectionHowItWorks
